import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Button,
  Center,
  Flex,
  Icon,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  SimpleGrid,
  Stack,
  Tag,
  TagLabel,
  TagLeftIcon,
  TagRightIcon,
  Text,
} from "@chakra-ui/react";
import { StepsProps } from "./TrackerStepperProps";
import * as FaIcons from "react-icons/fa";
import { BsCircleFill, BsExclamationCircle } from "react-icons/all";
import moment from "moment";
import { useState } from "react";
import classNames from "classnames";
require("./TrackerStepper.scss");

export const TrackerStepper = (steps: StepsProps[]) => {
  const formatedSteps = Object.keys(steps).map((step, index) => {
    return steps[index];
  });

  const firstNotStarted = formatedSteps.find((element: StepsProps) => {
    return (
      element.stepStatus !== "Complete" && element.stepStatus !== "Completed"
    );
  });

  let indexFirstNotStarted = formatedSteps.findIndex(
    (x) => x === firstNotStarted
  );

  if (indexFirstNotStarted === -1) indexFirstNotStarted = formatedSteps.length;

  const [accordionIndex] = useState(indexFirstNotStarted);

  const accordionItemClasses = (
    index: number,
    stepStatus: string | undefined
  ) =>
    classNames({
      step: true,
      step_first: index === 0,
      step_completed: stepStatus === "Completed" || stepStatus === "Complete",
      step_current: index === accordionIndex,
      step_last: index === formatedSteps.length - 1,
    });

  const getIcon = (
    index: number,
    icon: string | undefined,
    stepStatus: string | undefined
  ) => {
    return index <= indexFirstNotStarted &&
      (stepStatus === "Completed" || stepStatus === "Complete")
      ? FaIcons.FaCheckCircle
      : stepStatus === "onHold" && index === indexFirstNotStarted
      ? FaIcons.FaPauseCircle
      : icon!
      ? (FaIcons as any)[icon]
      : BsCircleFill;
  };

  return (
    <Accordion defaultIndex={[0]} allowMultiple>
      {formatedSteps && formatedSteps?.length > 0 ? (
        <Flex flexDir="column" width="100%" marginTop={4}>
          {formatedSteps.map(
            (
              {
                label,
                content,
                stepStatus,
                subTasks,
                onHoldReason,
                onHoldUntil,
                date,
                isAccordion,
                icon,
              },
              index
            ) => {
              return (
                <AccordionItem
                  border={0}
                  w={"100%"}
                  key={label}
                  className={accordionItemClasses(index, stepStatus)}
                >
                  <Flex
                    w={"100%"}
                    minH={"50px"}
                    display="flex"
                    flexDir="row"
                    boxShadow={index === indexFirstNotStarted ? 2 : 0}
                  >
                    <Stack direction="row" w={"100%"}>
                      <Flex backgroundColor={"gray.100"} className={"steps_bg"}>
                        <Flex
                          direction="column"
                          justifyContent={"start"}
                          className={"steps_bg_secondary"}
                          paddingY={3}
                          paddingX={1}
                        >
                          <Icon
                            className={"step_icon"}
                            as={getIcon(index, icon, stepStatus)}
                            w={5}
                            h={5}
                          />
                        </Flex>
                      </Flex>
                      <Flex
                        direction="column"
                        alignItems={"flex-start"}
                        textAlign={"left"}
                        className={"step_description_wrapper"}
                        w={"100%"}
                        p={2}
                        borderBottom={"1px solid"}
                        borderColor="gray.400"
                      >
                        <AccordionButton
                          justifyContent={"space-between"}
                          _hover={{ backgroundColor: "transparent" }}
                          p={0}
                          _focus={{ border: 0 }}
                        >
                          <div className="d-flex flex-wrap flex-column">
                            <Text
                              fontWeight="600"
                              fontSize={"lg"}
                              textAlign={"left"}
                            >
                              <span
                                style={{
                                  textTransform: "capitalize",
                                  marginRight: "10px",
                                }}
                              >
                                {label}
                              </span>
                              {date && (
                                <Tag variant="solid" className={"step_tag"}>
                                  {" "}
                                  {date}
                                </Tag>
                              )}
                              {onHoldReason && (
                                <Tag
                                  variant="subtle"
                                  colorScheme="red"
                                  marginBottom={1}
                                >
                                  <TagLeftIcon
                                    boxSize="12px"
                                    as={BsExclamationCircle}
                                  />
                                  on hold until{" "}
                                  {moment(onHoldUntil).format("DD MMM yy")},
                                  Reason: {onHoldReason}
                                </Tag>
                              )}
                            </Text>
                            <Text
                              fontWeight="400"
                              fontSize={"md"}
                              textAlign={"left"}
                            >
                              {content}
                            </Text>
                          </div>
                          {isAccordion && <AccordionIcon />}
                        </AccordionButton>
                        {isAccordion && (
                          <AccordionPanel w={"100%"} p={0}>
                            <Flex flexDir={"column"} w={"100%"}>
                              {subTasks && subTasks?.length > 0 && (
                                <SimpleGrid
                                  w={"100%"}
                                  minChildWidth="{100%, 150px}"
                                  spacing={2}
                                  position={"relative"}
                                >
                                  {subTasks?.map(
                                    ({ label, detail, subStepStatus }, i) => (
                                      <Tag
                                        size={"md"}
                                        colorScheme={
                                          subStepStatus === "Completed" ||
                                          subStepStatus === "Complete"
                                            ? "blue"
                                            : subStepStatus === "NotStarted"
                                            ? "gray"
                                            : "orange"
                                        }
                                        variant="outline"
                                        key={label}
                                      >
                                        <TagLeftIcon
                                          boxSize="12px"
                                          as={
                                            subStepStatus === "Completed" ||
                                            subStepStatus === "Complete"
                                              ? FaIcons.FaCheckCircle
                                              : subStepStatus === "NotStarted"
                                              ? FaIcons.FaStopCircle
                                              : FaIcons.FaPlayCircle
                                          }
                                          opacity={
                                            stepStatus === "onHold" ? 0.7 : 1
                                          }
                                        />
                                        <TagLabel
                                          fontWeight={"600"}
                                          opacity={
                                            stepStatus === "onHold" ? 0.7 : 1
                                          }
                                        >
                                          {label}
                                        </TagLabel>
                                        <Popover placement="top-start">
                                          <PopoverTrigger>
                                            <Button
                                              p={1}
                                              variant="ghost"
                                              marginLeft={"auto"}
                                              zIndex={1}
                                              w="{18px}"
                                              minW={"auto"}
                                              h={"18px"}
                                              as={Center}
                                            >
                                              <TagRightIcon
                                                boxSize="12px"
                                                color={"blue.700"}
                                                as={FaIcons.FaInfoCircle}
                                                m="auto"
                                                zIndex={1}
                                              />
                                            </Button>
                                          </PopoverTrigger>
                                          <PopoverContent
                                            bg={"white"}
                                            dropShadow={"md"}
                                            color={"gray.700"}
                                            rounded={4}
                                          >
                                            <PopoverArrow />
                                            <PopoverCloseButton />
                                            <PopoverHeader
                                              fontWeight={"700"}
                                              textTransform="uppercase"
                                            >
                                              {label}
                                            </PopoverHeader>
                                            <PopoverBody>{detail}</PopoverBody>
                                          </PopoverContent>
                                        </Popover>
                                      </Tag>
                                    )
                                  )}
                                </SimpleGrid>
                              )}
                              {!subTasks && content}
                            </Flex>
                          </AccordionPanel>
                        )}
                      </Flex>
                    </Stack>
                  </Flex>
                </AccordionItem>
              );
            }
          )}
        </Flex>
      ) : null}
    </Accordion>
  );
};
